import { FlashBagType } from '@enums/flashbag.ts';
import { trans } from '@tools/translation';
import { eventBus } from '@tools/event-bus';

const flashBag = (type: FlashBagType, message: string, duration?: number): void => {
  eventBus.dispatchEvent(
    new CustomEvent('flashbags-push', {
      detail: {
        type,
        message,
        duration,
      },
    }),
  );
};

const flashBagSuccess = (message: string, duration?: number): void => {
  flashBag(FlashBagType.SUCCESS, message, duration);
};

const flashBagError = (message?: string): void => {
  if (message) {
    flashBag(FlashBagType.ERROR, message);
    return;
  }
  flashBag(FlashBagType.ERROR, trans('global.error'));
};

export { flashBag, flashBagSuccess, flashBagError };
